import './App.css';
import ScrollToTop from "./ScrollToTop";
import CookieBanner from "./Components/Cookies/CookieBanner";
import { useEffect } from "react";                     // ADDED
import { isAnalyticsAllowed } from "./utils/analytics"; // ADDED
import "./i18n";
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar';
import TopBar from './Components/TopBar/TopBar';
import Home from './Pages/Home/Home';
import Marquee from './Components/Marquee/Marquee';
import Footer from './Components/Footer/Footer';
import ContactForm from './Components/ContactForm';
import FAQ from './Pages/FAQ/FAQ';
// import ImpactStories from 'Frontend/Pages/About/ImpactStories';
import VisionMission from './Pages/About/VisionMission';
// import Team from './Pages/About/Team';
import Donate from './Pages/Donate/Donate';
import AssistedLiving from './Pages/What_we_do/AssistedLiving';
import MedicalSupport from './Pages/What_we_do/MedicalSupport';
import PalliativeCare from './Pages/What_we_do/PalliativeCare';
import FamilyConsults from './Pages/What_we_do/FamilyConsults';
import MealsNutrition from './Pages/What_we_do/MealsNutrition';
import DementiaCare from './Pages/What_we_do/DementiaCare';
import MentalHealth from './Pages/What_we_do/MentalHealth';
import RecoveryRehab from './Pages/What_we_do/RecoveryRehab';
import Contactus from './Pages/Contact/Contactus';
import Photos from './Pages/Gallery/Photos';
import Videos from './Pages/Gallery/Videos';
import News from './Pages/Gallery/News';
import KnowAboutOrg from './Pages/About/KnowAboutOrg';
import GovBody from './Pages/About/GovBody'
import RewardsRecognization from './Pages/About/RewardsRecognization';
import CriticalPatientSupport from './Pages/What_we_do/CriticalPatientSupport';
// import KnowAboutOrg from 'Frontend/Pages/About/KnowAboutOrg';
import DocumentsRequired from './Pages/About/DocumentsRequired';
import GuestVisitActivities from './Pages/Gallery/GuestVisitActivities';
import MedicallSupport from './Pages/Gallery/MedicallSupport';
import ManagementDesk from './Components/Hero/ManagementDesk';
import CookiePolicy from "./Pages/Cookiepolicy/CookiePolicy";
import TermsConditions from './Pages/Terms/TermsConditions';
function App() {

  // COOKIE ANALYTICS CONTROL (ADDED)
  useEffect(() => {

    if (isAnalyticsAllowed()) {

      console.log("Analytics cookies allowed");

      // Future analytics scripts can load here
      // Example: Google Analytics / Meta Pixel

    }

  }, []);

  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTop/>
      <TopBar/>
      <Navbar/>
      <Marquee/>
      <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/FAQ' element={<FAQ/>}/>
          <Route path='/VissionMission' element={<VisionMission/>}></Route>
          {/* <Route path='/ImpactStories' element={<ImpactStories/>}></Route> */}
          {/* <Route path='/Team' element={<Team/>}></Route> */}
          {/* <Route path='/AboutOrg' element={<Team/>}></Route> */}
          <Route path='/Donate' element={<Donate/>}></Route>
          <Route path='/AssistedLiving' element={<AssistedLiving/>}></Route>
          <Route path='/MedicalSupport' element={<MedicalSupport/>}></Route>
          <Route path='/PalliativeCare' element={<PalliativeCare/>}></Route>
          <Route path='/FamilyConsults' element={<FamilyConsults/>}></Route>
          <Route path='/MealsNutrition' element={<MealsNutrition/>}></Route>
          <Route path='/DementiaCare' element={<DementiaCare/>}></Route>
          <Route path='/MentalHealth' element={<MentalHealth/>}></Route>
          <Route path='/RecoveryRehab' element={<RecoveryRehab/>}></Route>
          <Route path='/CriticalPatientSupport' element={<CriticalPatientSupport/>}></Route>
          <Route path='/MedicallSupport' element={<MedicallSupport/>}></Route>
          <Route path='/ContactForm' element={<ContactForm/>}></Route>
          <Route path='/TermsConditions' element={<TermsConditions/>}></Route>

          <Route path='/ManagementDesk' element={<ManagementDesk/>}></Route>

          <Route path='/Contactus' element={<Contactus/>}></Route>
          <Route path='/Photos' element={<Photos/>}></Route>
          <Route path='/Videos' element={<Videos/>}></Route>
          <Route path='/News' element={<News/>}></Route>
          <Route path='/KnowAboutOrg' element={<KnowAboutOrg/>}></Route>
          <Route path='/VisionMission' element={<VisionMission/>}></Route>
          <Route path='/GovBody' element={<GovBody/>}></Route>
          <Route path='/RewardsRecognization' element={<RewardsRecognization/>}></Route>
          <Route path='/DocumentsRequired' element={<DocumentsRequired/>}></Route>
          <Route path='/GuestVisitActivities' element={<GuestVisitActivities/>}></Route>
          <Route path='/CookiePolicy' element={<CookiePolicy/>}></Route>
      </Routes>
      <CookieBanner/>
       <Footer/>
      </BrowserRouter>

    </div>
  );
}

export default App;